import React from 'react'

// Icons
import SchoolIcon from '@mui/icons-material/School';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DomainIcon from '@mui/icons-material/Domain';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const WhyUs = () => {
    return (
        <div className="mt-24 mb-36 p-6 mx-auto max-w-sm sm:max-w-xl md:max-w-full lg:max-w-screen-xl space-y-40">
            <div className="flex flex-wrap -mx-4">
                <div className="w-full px-4">
                    <div className="mx-auto mb-4 max-w-[510px] text-center md:mb-2">
                        <h2 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">
                            Why Choose Sky Global Education?
                        </h2>
                        <p className="subdesc">
                            9 Key Reasons to Trust Us with Your Academic Future
                        </p>
                    </div>
                </div>
            </div>
            <div className="grid row-gap-8 sm:row-gap-0 sm:grid-cols-2 lg:grid-cols-3">
                <div className="p-8 border-b sm:border-r">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-blue-100 sm:w-16 sm:h-16 shadow-md">
                            <DoneOutlineIcon className="w-8 h-8 text-blue-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Expert Guidance</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            Our seasoned experts help you navigate the complexities of international education and admissions seamlessly.
                        </p>
                    </div>
                </div>
                <div className="p-8 border-b lg:border-r">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 sm:w-16 sm:h-16 shadow-md">
                            <AssignmentTurnedInIcon className="w-10 h-10 text-green-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Personalized Solutions</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            We tailor our services to fit your unique academic aspirations, ensuring a perfect match with your goals.
                        </p>
                    </div>
                </div>
                <div className="p-8 border-b sm:border-r lg:border-r-0">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-purple-100 sm:w-16 sm:h-16 shadow-md">
                            <CheckCircleOutlineIcon className="w-10 h-10 text-purple-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Full Transparency</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            Our process is 100% transparent, keeping you informed at every step of your educational journey.
                        </p>
                    </div>
                </div>
                <div className="p-8 border-b lg:border-r">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-yellow-100 sm:w-16 sm:h-16 shadow-md">
                            <AttachMoneyIcon className="w-10 h-10 text-yellow-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Affordable Options</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            Get premium services at cost-effective rates, making global education accessible to everyone.
                        </p>
                    </div>
                </div>
                <div className="p-8 border-b sm:border-r">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 sm:w-16 sm:h-16 shadow-md">
                            <DomainIcon className="w-10 h-10 text-red-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">University Matchmaking</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            We help you choose the perfect university and course that align with your academic profile and career goals.
                        </p>
                    </div>
                </div>
                <div className="p-8 border-b">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-teal-100 sm:w-16 sm:h-16 shadow-md">
                            <VolunteerActivismIcon className="w-10 h-10 text-teal-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Application Support</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            Get expert guidance on crafting compelling applications, essays, and SOPs that stand out.
                        </p>
                    </div>
                </div>
                <div className="p-8 border-b sm:border-r lg:border-b-0">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-indigo-100 sm:w-16 sm:h-16 shadow-md">
                            <AssignmentOutlinedIcon className="w-10 h-10 text-indigo-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Visa Assistance</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            From document preparation to interview coaching, we simplify the visa process for you.
                        </p>
                    </div>
                </div>
                <div className="p-8 border-b lg:border-b-0 lg:border-r">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-pink-100 sm:w-16 sm:h-16 shadow-md">
                            <RecordVoiceOverIcon className="w-10 h-10 text-pink-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Pre-Departure Support</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            Comprehensive guidance on accommodation, travel arrangements, and cultural orientation for a smooth transition.
                        </p>
                    </div>
                </div>
                <div className="p-8 sm:border-r lg:border-r-0">
                    <div className="max-w-md text-center">
                        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-orange-100 sm:w-16 sm:h-16 shadow-md">
                            <SchoolIcon className="w-10 h-10 text-orange-600" />
                        </div>
                        <h6 className="mb-2 font-semibold leading-5">Scholarship Opportunities</h6>
                        <p className="mb-3 text-sm text-slate-400 leading-5">
                            We help you identify and secure scholarships to ease your financial burden.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyUs;
